import React, { useEffect, useState } from "react";
import LOGO from "../../assets/logo.png";

const MaintenancePage = () => {

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-[#F0F0F0] text-gray-800 px-4">
      <img src={LOGO} alt="everbary"
        className="w-40 mb-6"
      />

      <h1 className="text-4xl font-bold mb-4 text-[#15AABF]">We'll Be Back Soon!</h1>

      <p className="text-lg text-center max-w-xl mb-8">
        Our website is currently undergoing scheduled maintenance.
        We should be back shortly. Thank you for your patience.
      </p>

     
    </div>
  );
};

export default MaintenancePage;
